import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const DictionariesActionTypes = {
  FETCH_POSSIBLE_ORDER_STATUSES: createSubtypes('dictionaries|fetchPossibleOrderStatuses'),
  FETCH_OPPORTUNITY_STAGES: createSubtypes('dictionaries|fetchOpportunityStages'),
  FETCH_PROPOSAL_ITEMS: createSubtypes('dictionaries|fetchProposalItems'),
  FETCH_ROOF_ESTIMATE_OPTIONS: createSubtypes('dictionaries|fetchRoofEstimateOptions'),
  FETCH_REQUEST_NEW_PROPOSAL_REASONS: createSubtypes('dictionaries|fetchRequestNewProposalReasons'),
};
